import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRightIcon } from "lucide-react";
import { thoughts, thoughtMeta } from "../data/thoughts";
import { SectionHeading } from "../components/SectionHeading";
import { ThoughtFeature } from "../components/ThoughtFeature";
import { EYEBROW, H3 } from "../utils/typography";
import { usePageTitle } from "../hooks/usePageTitle";
export function Thoughts() {
  const [featured, ...rest] = thoughts;
  usePageTitle("Thoughts");
  return <main id="main-content" tabIndex={-1} className="w-full bg-cream px-6 pb-24 pt-36 md:px-12 md:pb-32 md:pt-48 lg:px-20 lg:pb-40" data-id="element-530" data-mp="1wxoq6l8ttklk">
      <SectionHeading id="thoughts-page-heading" title="THOUGHTS" as="h1" data-id="element-531" data-mp="1rxty4edbeoyx" />

      {featured && <ThoughtFeature thought={featured} showSeeAll={false} data-id="element-532" data-mp="1myz8otkue25u" />}

      {rest.length > 0 && <section aria-labelledby="archive-heading" className="mt-24 md:mt-32 lg:mt-40" data-id="element-533" data-mp="gkzvzfmzlcs2">
          <h2 id="archive-heading" className={`${EYEBROW} text-espresso/70`} data-id="element-534" data-mp="bklygrj0hl8a">
            Earlier
          </h2>
          <ul className="mt-6 border-b border-espresso/10" data-id="element-535" data-mp="3rewbiym9tb1">
            {rest.map(post => <li key={post.slug} className="border-t border-espresso/10" data-id="element-536" data-mp="7qxdq4r8bm94">
                <Link to={`/thoughts/${post.slug}`} className="group grid grid-cols-12 items-center gap-4 py-8 md:gap-8" data-id="element-537" data-mp="3py3bkh9qg5hy">
                  <span className="col-span-12 text-sm text-espresso/70 md:col-span-2" data-id="element-538" data-mp="3uyhmq86mrvk7">
                    {thoughtMeta(post)}
                  </span>
                  <div className="col-span-12 md:col-span-7" data-id="element-539" data-mp="3kza9dkzwc0x3">
                    <h3 className={`${H3} text-espresso transition-colors duration-150 group-hover:text-rust`} data-id="element-540" data-mp="377c7nv8il7ay">
                      {post.title}
                    </h3>
                    <p className="mt-2 line-clamp-2 text-espresso/70" data-id="element-541" data-mp="3c42ia31jvaoz">{post.excerpt}</p>
                  </div>
                  <span className={`col-span-6 ${EYEBROW} text-espresso/70 md:col-span-2`} data-id="element-542" data-mp="327zktahn808d">
                    {post.category}
                  </span>
                  <div className="col-span-6 flex justify-end md:col-span-1" data-id="element-543" data-mp="2j45t5hskhigo">
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-espresso/15 text-espresso transition-colors duration-150 group-hover:border-rust group-hover:bg-rust group-hover:text-cream" data-id="element-544" data-mp="2ece090lxv0nd">
                      <ArrowUpRightIcon className="h-4 w-4" data-id="element-545" data-mp="24gay3ur3720f" />
                    </span>
                  </div>
                </Link>
              </li>)}
          </ul>
        </section>}
    </main>;
}